import React, { Component } from 'react';
import { Container, Card, CardBody, Row, Col, Collapse, CardHeader, FormGroup, Input, Label, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";
import "nouislider/distribute/nouislider.css";
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import "./datatables.scss"

import { internmentTypesUrl } from '../../helpers/url';

import { AddFacilityVariable } from './AddFacilityVariables';

class FacilityDataTypes extends Component {
    constructor(props) {
        super(props);
        this.state={
            breadcrumbItems : [
                { title : "Facility", link : "#" },
                { title : "Data Types", link : "#" },
            ],

            newData: [],

            dataSet: [
                ['x', 'x', 'x', 'x', 'x', 'x'],
            ]
        }
    }
    
    componentDidMount() {
        const jwt = JSON.parse(sessionStorage.getItem("authUser"))
        const accessToken = jwt.jwtToken
        let fetchData = fetch(internmentTypesUrl, {
            method: "GET",
            headers: {"Content-Type": "application/json", "Authorization": accessToken}
        }).then(res=>res.json())
        
        Promise.all([fetchData])
        .then(([data]) => {
            let  all = []
            data.map(each => {
                const propertyNames = Object.values(each);
                all.push(propertyNames)
            });
           
            this.setState({
                newData: all
            })
        })
        .catch(err => {
            console.log("error", err)
        })
    }
    
    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    <Breadcrumbs title="Facility Manager" breadcrumbItems={this.state.breadcrumbItems} />

                        <Row>
                            <Col xl={3} lg={4}>
                                <Card>
                                    <CardHeader className="bg-transparent border-bottom">
                                        <h5 className="mb-0">Filters</h5>
                                    </CardHeader>

                                    <div className="custom-accordion">
                                        <CardBody className="border-top">
                                            <div>
                                                <h5 className="font-size-14 mb-0"><Link to="#" className="text-dark d-block" onClick={() => this.setState({aLevel : !this.state.aLevel})} >Data Acquisition Level <i className={this.state.aLevel === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i></Link></h5>
    
                                                <Collapse isOpen={this.state.aLevel} id="collapseExample1">
                                                        <FormGroup row onChange={event => this.stateHandling(event)}>
                                                    <div className="mt-4">
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={6} id="productdiscountRadio6" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio6">50% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={5} id="productdiscountRadio5" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio5">40% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={4} id="productdiscountRadio4" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio4">30% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={3} id="productdiscountRadio3" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio3">20% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={2} id="productdiscountRadio2" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio2">10% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={1} id="productdiscountRadio1" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio1">Less than 10%</Label>
                                                        </div>
                                                    </div>
                                                    </FormGroup>
        
                                                </Collapse>
                                            </div>
                                        </CardBody>
    
                                        <CardBody className="border-top">
                                            <div>
                                                <h5 className="font-size-14 mb-0"><Link to="#" className="collapsed text-dark d-block" onClick={() => this.setState({rating : !this.state.rating})}>Internal Assesment Rating <i className={this.state.rating === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i></Link></h5>
    
                                                <Collapse isOpen={this.state.rating} id="collapseExample3">
                                                     <FormGroup row onChange={event => this.stateHandlingInternalAssessment(event)}>
                                                    <div className="mt-4">
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={4} id="productratingRadio1" name="productratingRadio1" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productratingRadio1">4 <i className="mdi mdi-star text-warning"></i>  & Above</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={3} id="productratingRadio2" name="productratingRadio1" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productratingRadio2">3 <i className="mdi mdi-star text-warning"></i>  & Above</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={2} id="productratingRadio3" name="productratingRadio1" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productratingRadio3">2 <i className="mdi mdi-star text-warning"></i>  & Above</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={1} id="productratingRadio4" name="productratingRadio1" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productratingRadio4">1 <i className="mdi mdi-star text-warning"></i></Label>
                                                        </div>
                                                    </div>
                                                    </FormGroup>
                                                </Collapse>
                                            </div>
                                        </CardBody>
                                        
                                    </div>
                                </Card>
                            </Col>
                            <Col lg={9}>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h4">Available Types</CardTitle>
                                        <CardBody className="border-top">
                                            <div>
                                                <p>Here is the list of all types used in the system in different language versions. 
                                                    The list includes the status if the type is meant to be hide. 
                                                    Meaning not displayed in the interface.</p>
                                            </div>
                                        </CardBody>
                                        {this.state.newData?.length > 0 &&
                                        <AddFacilityVariable dataInfo={this.state.newData} />
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container> 
                </div>
            </React.Fragment>
        );
    }
}

export default FacilityDataTypes;